import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import { Chart } from "primereact/chart";
import { useSelector, useDispatch } from 'react-redux';
import * as jobConstants from "../../enums/jobs";
import moment from "moment";

import {
  setFilterReportType,
  fetchCustomReportData,
} from "./reportSlice";

export const CustomBusinessVolumnExpendedView = () => {
  const navigate = useNavigate();
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  const protrackReports = useSelector((state) => state.reports);
  const jobState = useSelector((state) => state.job);
  const {
    userId,
    clientId,
    appLanguage,
  } = jobState;
  const {
    customReportList,
    customBusinessTypeReportList,
    reportStartDate,
    reportEndDate,
    filterChannelType,
    filterDocType,
    tabViewType,
    filterReportType,
  } = protrackReports;
  const categories = jobConstants.REPORT_FILTER_TYPE;
  const dispatch = useDispatch();
  const stackedBarTopLabels = {
    id: 'stackedBarTopLabels',
    afterDatasetsDraw(chart) {
      const { ctx, data, scales: { x, y } } = chart;
      const volData = data.datasets[0]?.data || [];
      ctx.save();
      ctx.font = 'bold 11px sans-serif';
      ctx.fillStyle = '#333';
      ctx.textAlign = 'center';
      volData.forEach((val, i) => {
        const xPos = x.getPixelForValue(i);
        const yPos = y.getPixelForValue(val || 0) - 6;
        ctx.fillText(val || 0, xPos, yPos);
      });
      ctx.restore();
    },
  };

  useEffect(() => {
    const bussTypeVol = customReportList?.VolBusType ? customReportList?.VolBusType : [];
    const bussTypeVolLabels = bussTypeVol?.map(item => item.businesstypename);
    const bussTypeVolValues = bussTypeVol?.map(item => item.cnt);

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    const data = {
      labels: bussTypeVolLabels,
      datasets: [
        {
          type: "bar",
          label: appLanguage["report.custom.label.completed-documents"],
          backgroundColor: '#7F7F7F',
          data: bussTypeVolValues,
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 1,
      plugins: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        legend: {
          display: false
        },

        // legend: {
        //     labels: {
        //         color: textColor,
        //     },
        // },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            display: false,
          },
        },
        y: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };
    setChartData(data);
    setChartOptions(options);
  }, [customReportList, appLanguage]);

  const changeReportType = (e) => {
    dispatch(setFilterReportType(e.value));
    let filterParams = {
      clientId: clientId,
      userId: userId,
      typeId: tabViewType,
      channelType: filterChannelType.join("|"),
      filterType: filterDocType,
      fromDate: moment(reportStartDate).format("YYYY-MM-DD"),
      toDate: moment(reportEndDate).format("YYYY-MM-DD"),
      reportType: e.value,
    };
    dispatch(fetchCustomReportData(filterParams));
  }

  const downloadCustomBusinessTypeReport = () => {
    downloadCsv(customBusinessTypeReportList, 'custom_business_type_report.csv');
  }

  // Convert JSON to CSV
  const jsonToCsv = (jsonData) => {
    const isArray = Array.isArray(jsonData);
    if (isArray) {
      const headers = Object.keys(jsonData[0]);
      const csvRows = [];
      csvRows.push(headers.join(','));
      jsonData.forEach(item => {
        const values = headers.map(header => {
          const value = item[header];
          return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
        });
        csvRows.push(values.join(','));
      });
      return csvRows.join('\n');
    } else {
      const headers = Object.keys(jsonData);
      const values = headers.map(header => {
        const value = jsonData[header];
        return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
      });
      return `${headers.join(',')}\n${values.join(',')}`;
    }
  };

  // Trigger CSV download
  const downloadCsv = (jsonData, fileName) => {
    const csvData = jsonToCsv(jsonData);
    console.log('CSV Data:', csvData);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  return (
    <div className="comms-sla-met-wrapper">
      <div className="comms-sla-met-inner-wrap">
        <div className="left-col box-white">
          <h3 style={{ marginLeft: '115px' }}>
            {appLanguage["report.custom.label.volumn-by-business-type"]}
            <ul className="comms-sla-radio-box">
              {categories.map((category) => {
                return (
                  <li key={category.key}>
                    <label htmlFor={category.key}>{category.name}</label>
                    <RadioButton
                      inputId={category.key}
                      name={category.key}
                      value={category.key}
                      onChange={(e) => changeReportType(e)}
                      checked={
                        filterReportType === category.key
                      }
                    />
                  </li>
                );
              })}
            </ul>
          </h3>
          <div className="card" style={{ minWidth: '0px' }}>
            <Chart
              type="line"
              data={chartData}
              options={chartOptions}
              plugins={[stackedBarTopLabels]}
              height={470}
            />
          </div>
        </div>
        <div className="right-col">
          <div className="applied-filter-box">
            <p className="title">Applied Filters</p>
            <p style={{ width: '100px' }}>{moment(reportStartDate).format("DD MMM YYYY")} – {moment(reportEndDate).format("DD MMM YYYY")}</p>
            <p>{filterChannelType == 0 ? 'DOCUMENT' : filterChannelType == 1 ? 'EMAIL' : filterChannelType == 2 ? 'SMS' : 'ALL'}</p>
            <p>{filterDocType === 1 ? 'BATCH' : filterDocType === 2 ? 'ADHOC' : 'ALL'}</p>
          </div>
          <div className="comms-btn-wrapper">
            <button className="return-icon-comms" onClick={() => navigate("/reports")}>Return</button>
            <button className="download-icon-comms" onClick={downloadCustomBusinessTypeReport}>Download</button>
          </div>
        </div>
      </div>
      {/* <hr className="expended-graph-footer-border" /> */}
    </div>
  );
};
